import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
const Skills = (props:any) => {
    const { category } = useParams();
    return <><h1>Skills</h1><p>{category}</p></>;
  };
  
  export default Skills;